import { readRemaining1u8soafhjma7y as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readRemaining(_this__u8e3s4.h5m().w5o(), $completion));
  return SavedHttpCall().f5q(_this__u8e3s4.c5m_1, _this__u8e3s4.h5o(), _this__u8e3s4.h5m(), responseBody);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      static f5q(client, request, response, responseBody) {
        var $this = this.g5o(client);
        $this.d5q_1 = responseBody;
        $this.e5m_1 = new (SavedHttpRequest())($this, request);
        $this.f5m_1 = new (SavedHttpResponse())($this, $this.d5q_1, response);
        checkContentLength(contentLength(response), fromInt($this.d5q_1.length), request.p5o());
        $this.e5q_1 = true;
        return $this;
      }
      j5o() {
        return this.e5q_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.g5q_1 = origin;
        this.h5q_1 = call;
      }
      o5o() {
        return this.h5q_1;
      }
      gw() {
        return this.g5q_1.gw();
      }
      p5o() {
        return this.g5q_1.p5o();
      }
      q5o() {
        return this.g5q_1.q5o();
      }
      i5o() {
        return this.g5q_1.i5o();
      }
      a2p() {
        return this.g5q_1.a2p();
      }
      b56() {
        return this.g5q_1.b56();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.i5q_1 = call;
        this.j5q_1 = body;
        this.k5q_1 = origin.x5o();
        this.l5q_1 = origin.y5o();
        this.m5q_1 = origin.z5o();
        this.n5q_1 = origin.a5p();
        this.o5q_1 = origin.b56();
        this.p5q_1 = origin.gw();
      }
      o5o() {
        return this.i5q_1;
      }
      x5o() {
        return this.k5q_1;
      }
      y5o() {
        return this.l5q_1;
      }
      z5o() {
        return this.m5q_1;
      }
      a5p() {
        return this.n5q_1;
      }
      b56() {
        return this.o5q_1;
      }
      gw() {
        return this.p5q_1;
      }
      w5o() {
        return ByteReadChannel(this.j5q_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save1y71vsgu0wj47,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
